import styled, { css } from 'styled-components';
import Icon from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
import { getButtonVariantStyles, getButtonVisualVariantStyles } from './helpers';
/**
 * Button container
 */
export const buttonContainerStyles = ({ theme, $variant, $visualStyle, $useBackgroundFill, }) => css `
	// added higher specificity to override core-ui styling
	&&& {
		display: ${$variant === 'toggle' ? 'inline-block' : 'inline-flex'};
		align-items: center;
		background: ${$useBackgroundFill ? theme.colors.blanc.bgButton : 'transparent'};

		gap: ${pxToRem(theme.spacing['200'])};
		justify-content: center;
		width: 100%;
		margin: 0;
		padding: ${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['350'])};
		border-radius: ${pxToRem(theme.borderRadius.m)};
		border: none; // remove CORE-UI added border
		cursor: pointer;
		text-align: center;
		text-decoration: none;
		text-transform: none;
		line-height: ${pxToRem(theme.lineHeights['400'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			${$variant !== 'toggle' &&
    css `
				width: auto;
			`}
		}

		&:hover {
			${ButtonIconChild}:first-child {
				right: 3px;
			}

			${ButtonIconChild}:last-child {
				left: 3px;
			}
		}

		${getButtonVariantStyles({ variant: $variant })}
		${getButtonVisualVariantStyles({ visualStyle: $visualStyle })}
	}
`;
export const ButtonContainer = styled.button `
	${buttonContainerStyles}
`;
/**
 * ButtonText
 */
export const ButtonText = styled(Typography).attrs({
    variant: 'button-link',
}) ``;
/**
 * ButtonIconChild
 */
export const buttonIconChildStyles = () => css `
	font-weight: normal;
	position: relative;

	transition: all 0.2s;

	&:first-child {
		right: 0;
	}

	&:last-child {
		left: 0;
	}
`;
export const ButtonIconChild = styled(Icon) `
	${buttonIconChildStyles}
`;
/**
 * Button icon
 */
export const buttonIconContainerStyles = ({ theme, $disabled, }) => css `
	padding: ${pxToRem(theme.spacing['200'])};
	border: none;
	border-radius: ${pxToRem(theme.borderRadius.m)};
	color: ${theme.colors.highlight.iconHover};
	font-size: ${pxToRem(18)}; // TODO: use design-token from anwb/icon when migrating that to SC
	line-height: ${pxToRem(18)}; // TODO: use design-token from anwb/icon when migrating that to SC
	background: transparent;

	${!$disabled &&
    css `
		&:focus,
		&:hover {
			> span {
				color: ${theme.colors.base.iconButton};
			}
		}
		&:active {
			> span {
				color: ${theme.colors.action.iconActive};
			}
		}
	`}
`;
export const ButtonIconContainer = styled.button `
	${buttonIconContainerStyles}
`;
//# sourceMappingURL=button.styled.js.map